import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { ROUTES } from '../../common/constants';
import Trailers from './Trailers';

const TrailerWrapper = () => {
  return (
    <Switch>
      <Route exact path={ROUTES.TRAILERS} component={Trailers} />
    </Switch>
  );
};

export default TrailerWrapper;
